export const environment = {
  production: false,
  apiBaseUrl: 'https://pink-moon-web-api.development.dokploy.vaheda.ir/api',
};